export default "__VITE_ASSET__CZ$RgtL6__"